(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["easylonger-instagram"] && !Shopify.designMode) return;
  try {
    
  const sections = document.querySelectorAll('.easylonger-instagram');

  sections.forEach((section) => {
    const dialog = section.querySelector('.easylonger-instagram__dialog');
    const frame = section.querySelector('.easylonger-instagram__frame');
    const closeButton = section.querySelector('.easylonger-instagram__close');
    const cards = section.querySelectorAll('.easylonger-instagram__card');

    if (!dialog || !frame || !closeButton) return;

    const buildEmbedUrl = (url) => {
      if (!url) return '';
      const cleanUrl = url.trim().replace(/\/$/, '');
      if (cleanUrl.includes('/embed')) return cleanUrl;
      return `${cleanUrl}/embed/captioned`;
    };

    const closeDialog = () => {
      frame.removeAttribute('src');
      dialog.close();
    };

    cards.forEach((card) => {
      card.addEventListener('click', () => {
        const embedUrl = buildEmbedUrl(card.dataset.instagramUrl);
        if (!embedUrl) return;
        frame.src = embedUrl;
        frame.title = card.dataset.instagramTitle || 'Instagram post';
        if (document.startViewTransition) {
          document.startViewTransition(() => dialog.showModal());
        } else {
          dialog.showModal();
        }
      });
    });

    closeButton.addEventListener('click', closeDialog);

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closeDialog();
    });

    dialog.addEventListener('cancel', () => {
      frame.removeAttribute('src');
    });
  });

  } catch(e) { console.error(e); }
})();
})();
